import {Button,Modal,message,Select,Spin,Tooltip} from 'antd';
import React, {Component}  from 'react';
import UM from 'UM';
import $ from '$'


const { Option, OptGroup } = Select;

export default class GuideTemp extends Component{

    state = {
        content: '',
    }

   setGuideText = ()=> {
        const { content } = this.state;
        const { setGuideText } = this.props;
        setGuideText && setGuideText(content);
    }
	openModal = () => {
        const { openModal } = this.props;
        openModal && openModal();
	}
    onContentChange = (val)=> {
        this.setState({content: val})
    }
    render(){
        let { content } = this.state
        const { isShowGetGuide, guideList } = this.props;
        const optionGroups = guideList.map((d, key) => {
            let options = d.list.map((v, index) => {
                let optionsContent = v.content.replace(v.key_words, `<span style="color:#f04134">${v.key_words}</span>`)
                return (<Option key={index} value={v.content}><div dangerouslySetInnerHTML={{__html: optionsContent}}></div></Option>)
            })
            return (<OptGroup key={key} label={d.content}>{options}</OptGroup>)
        });
        return (
            <Modal title="引导语模板" 
                visible={isShowGetGuide} 
                onOk={this.setGuideText}  
                onCancel={this.openModal}>
                <Select
                    mode="combobox"
                    value={content}
                    notFoundContent=""
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    onChange={this.onContentChange}
                    style={{ width: '80%' }}
                >
                    {optionGroups}
                </Select>
            </Modal>
        )
    }

}



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/components/guide_tml.js